import { Dayjs } from "dayjs";

import z from "zod";

/**
 * ReportOrdemComprasSchema
 */

export const ReportOrdemComprasSchema = z.object({
  ordemCompras: z.array(z.number()).optional(),
  centroCustos: z.array(z.number()).optional(),
  status: z.coerce.number(),
  fornecedores: z.array(z.number()).optional(),
  data: z.array(z.custom<Dayjs>().nullable()).optional(),
});

/**
 * ReportOrdemComprasForm
 */

export type ReportOrdemComprasForm = z.infer<typeof ReportOrdemComprasSchema>;